import { original_location } from '~/events/dataLayerBasic/global/original_location'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

export default ({ app }) => {
  window.dataLayer = window.dataLayer || []
  original_location()
  window.dataLayer.push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
  })

  app.router.afterEach((to, from) => {
    const user = app.store && app.store.state?.user?.userData ? app.store.state.user.userData : null

    if (!to.name.startsWith('checkout') || to.name.startsWith('checkout-finished')) {
      eventBus.$emit(eventDefinitions.USER.LOADED, { user })
    }

    if (!to.name.startsWith('checkout') || to.name.startsWith('checkout-finished')) {
      eventBus.$emit(eventDefinitions.SITE.PAGE_VIEW, {
        page_route_name: to.name,
        page_url: window.location.origin + to.fullPath,
        page_url_referrer: window.location.origin + from.fullPath,
      })
    }

    if (
      app.store &&
      app.store.state.cart &&
      (!to.name.startsWith('checkout') || to.name.startsWith('checkout-finished'))
    ) {
      eventBus.$emit(eventDefinitions.CART.LOADED, { cart: app.store.state.cart })
    }
  })
}
